module.exports = __webpack_public_path__ + "static/img/20171.858237f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20171.jpg
// module id = zsGq
// module chunks = 1